import {
  Box,
  Container,
  HStack,
  Icon,
  Link,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import { Logo } from '../Logo/Logo'
import React from "react"
import { ReactNode } from 'react';
import useAuth from '../hooks/useAuth'
import { FaFacebook, FaFacebookF, FaInstagram } from 'react-icons/fa';

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
      {children}
    </Text>
  );
};

export default function Footer() {
  const { loggedIn } = useAuth();
  return (
    <Box
      bg="gray.50"
      color={useColorModeValue('gray.700', 'gray.200')}>
      <Container as={Stack} maxW={'3xl'} py={10} pb={{base: 20, lg: 10}}>
        <SimpleGrid
          templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr' }}
          spacing={8}>
          <Stack spacing={6}>
            <Box>
              <Logo color={useColorModeValue('gray.700', 'white')} />
            </Box>
            <Text fontSize={'sm'}>
              © 2023 SphericMed. All rights reserved
            </Text>
          <HStack spacing={3}>
              <Link href={'https://www.facebook.com/bespheric/'}>
                <Icon boxSize="1rem" color='gray.700' as={FaFacebookF} />
                </Link>
                <Link href={'https://www.instagram.com/bespheric/'}>
                <Icon boxSize="1rem" color='gray.700' as={FaInstagram} />
              </Link>
          </HStack>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Customer Service</ListHeader>
            <Link href={'/contact-us'}>Contact Us</Link>
            <Link href={'/about'}>About Us</Link>
            {!loggedIn ? (<Link href={'/log-in'}>Sign in</Link>) :
            (<Link href={'/acc-settings'}>My Account</Link>)}
            <Link href={'/faq'}>FAQ</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Policies</ListHeader>
            <Link href={'/customer-agreement'}>Customer Agreement</Link>
            <Link href={'/terms-of-service'}>Terms of Service</Link>
            <Link href={'/shipping&return'}>Shipping & Return Policy</Link>
            <Link href={'/privacy-policy'}>Privacy Policy</Link>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  );
}